import api from './api';

export function activeHighlights(items, now = Date.now()) {
  return (Array.isArray(items) ? items : []).filter(item => {
    if (!item || !item.active || !item.title || !item.desktop_image_url) return false;
    const start = item.starts_at ? Date.parse(item.starts_at) : -Infinity;
    const end = item.ends_at ? Date.parse(item.ends_at) : Infinity;
    return !Number.isNaN(start) && !Number.isNaN(end) && start <= now && end > now;
  }).sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
}

export async function getHighlights(signal) {
  if (process.env.REACT_APP_EDITORIAL_PREVIEW === 'true') {
    const response = await fetch('/data/highlights-preview.json', { signal });
    if (!response.ok) throw new Error('Preview unavailable');
    return response.json();
  }
  const { data } = await api.get('/api/public/highlights', { timeout: 5000, signal });
  return Array.isArray(data) ? data : data.items || [];
}
